/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useState, useEffect, Fragment } from 'react';
import Button from '@mui/material/Button';
import { useStateContext } from '../../../contexts/ContextProvider';
import { getUsers, updateUsers } from '../../../api/api';
import SweetAlert from 'sweetalert2/src/sweetalert2.js';
import { FormGroup, Label, Container, Modal, Table, Input } from 'reactstrap';
import { Trash2, Plus, Edit } from 'react-feather';
import { getAuthzRoles } from '../../../api/api';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function containsSuccess(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Success');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}


function UpdateUsers({ oldUser }) {
  const { basictoaster, primary, setUsers, setLoading, setExecuting } = useStateContext();
  // init form data
  const [selectedRole, setSelectedRole] = useState('noRole');
  const [formData, setFormData] = useState({
    username: '',
    roles: [],
  });
  const [authzRoles, setAuthzRoles] = useState(false);
  const [errors, setErrors] = useState({});
  // open
  const [open, setOpen] = useState(false);
  const [abortController, setAbortController] = useState(new AbortController());

  const handleOpen = () => {
    // pre compile form data with selected user data
    let old_user_roles = JSON.parse(oldUser.roles)
    setFormData({
      username: oldUser.username,
      roles: old_user_roles,
    })
    // Create a new AbortController instance
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    // get all roles from api
    // get selections for all the form selects
    getAuthzRoles(newAbortController.signal).then((resp) => {
      if (!newAbortController.signal.aborted) {
        setAuthzRoles(resp);
      }
    }).catch((err) => {basictoaster("error", 'Errore ruoli', err, () => {})})
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    abortController.abort();
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // add role
  const addRole = () => {
    // if is not the default select option set the state
    if (selectedRole !== 'noRole') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        roles: [...prevFormData.roles, selectedRole],
      }));
    }
    // reset the select role to default
    setSelectedRole('noRole')
  };

  // remove role
  const removeRole = (roleToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      roles: prevFormData.roles.filter((role) => role !== roleToRemove),
    }));
  };

  // validate from callback
  const validateForm = useCallback(() => {
    const { username } = formData;
    const newErrors = {};

    if (!username) {
      newErrors.username = 'Il nome utente è richiesto';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData]);

  // validate form if input changes
  useEffect(() =>  {
    validateForm();
  }, [formData, validateForm])

  const updateUserHandler = () => {
    SweetAlert.fire({
        title: 'Sei sicuro?',
        text: 'Il tuo utente verrà modificato',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true
    })
        .then(async (result) => {
          if (result.value) {
            setExecuting(true);
            const userObj = {
              id: oldUser.id,
              username: formData.username,
              roles: JSON.stringify(formData.roles),
            };
            // console.log(userObj)
            await updateUsers(userObj).then(async (response) => {
              getUsers().then((newsResp) => {
                setUsers(newsResp);
                setLoading(false);
              }).catch((err) => {basictoaster("error", "Errore utenti", err, () => {})});
              if (containsSuccess(response)) {
                  SweetAlert.fire(
                      'Fatto!',
                      'Il tuo utente è stato modificato.',
                      'success'
                  );
                  // init form data
                  setFormData({
                    username: '',
                    roles: [],
                  })
              } else if (containsError(response)) {
                SweetAlert.fire(
                    'Errore!',
                    `Errore: ${response.Error}.`,
                    'error'
                );
              }
              setExecuting(false);
              setOpen(false);
            }).catch((err) => {basictoaster("error", 'Errore modifica utenti', err, () => {})});
          }
        });
  };

  // submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      updateUserHandler();
    }
  };
  
  // ALERT
  useEffect(() => {
    if (isObject(authzRoles) && containsError(authzRoles)) {
      basictoaster("error", "Errore ruoli", authzRoles.Error, setAuthzRoles)
    }
  }, [authzRoles, basictoaster])

  return (
    <>
      <button className='imgButton' onClick={handleOpen}><Edit width={20} /></button>
      <Modal
        isOpen={open}
        toggle={handleClose}
        centered
        backdropClassName={open ? 'BDModalOpen' : 'BDModalClosed'}
        modalClassName={open ? 'ModalOpen' : 'ModalClosed'}
      >
        <Container fluid={true} style={{ padding: '20px' }}>
          <h5>Modifica utente:</h5><br />
          <form style={{ margin: '10%', marginTop: '1%', marginBottom: '1%' }} onSubmit={handleSubmit} >
            {/* USERNAME */}
            <FormGroup>
              <Label htmlFor="username" className="col-form-label pt-0">Nome utente</Label>
              <input
                className="form-control"
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
              {errors.username && <div style={{ color: 'red' }}>{errors.username}</div>}
            </FormGroup>
            {/* ROLES */}
            <FormGroup>
              <Label htmlFor="roles" className="col-form-label pt-0">Ruoli</Label>
              <Input
                className="form-control"
                type="select"
                id="roles"
                name="roles"
                onChange={(e) => {setSelectedRole(e.target.value)}}
              >
                <option value="noRole">Nessun ruolo</option>
                {/* REMOVE THE ALREADY ADDED ROLE FROM THE AVIALABLE ROLES with filter */}
                {authzRoles && !containsError(authzRoles) && authzRoles.filter(role => !formData.roles.includes(role)).map((role) => (
                    <option key={role} value={role}>
                      {role}
                    </option>
                  )
                )}
              </Input>
              {selectedRole !== 'noRole' && (<button className='imgButton' onClick={addRole}><Plus width={20} /></button>)}
            </FormGroup>
            {formData.roles.length > 0 && (
              <>
                <h6>Ruoli aggiunti:</h6>
                <div style={{ overflow: 'scroll', width: '100%' }} className='shadowClass'>
                  <Table style={{ textAlign: 'center' }}>
                    <thead className="table-primary table-responsive">
                      <tr>
                        <th>Ruolo</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {formData.roles && formData.roles.map((role) => (
                        <tr key={role}>
                          <td>{role}</td>
                          <td><button type='button' className='imgButton' onClick={() => {removeRole(role)}} ><Trash2 width={20}/></button></td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div><br />
              </>
            )}
            <br />
            {/* BUTTONS */}
            <Button
              variant="contained"
              type="submit"
              style={{ backgroundColor: primary }}
            >
              Salva modifiche
            </Button>
            <Button
              variant="contained"
              type="button"
              onClick={handleClose}
              style={{ backgroundColor: 'gray', marginLeft: '1%' }}
            >
              Annulla
            </Button>
          </form>
        </Container>
      </Modal>
    </>
  );
}

export default UpdateUsers;
